import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_LOCALE, resolveSupportedLocale } from '../../locales/localeConfig';

const languageSlice = createSlice({
	name: 'language',
	initialState: { locale: DEFAULT_LOCALE },
	reducers: {
		changeLocale(state, { payload }) {
			return {
				...state,
				locale: resolveSupportedLocale(payload),
			};
		},
	},
});

export const selectCurrentLocale = (state) => state.language.locale;

export const { changeLocale } = languageSlice.actions;

export default languageSlice.reducer;
